import { render, staticRenderFns } from "./draftactivitymanagetable.vue?vue&type=template&id=0ce78ff5&scoped=true&"
import script from "./draftactivitymanagetable.vue?vue&type=script&lang=js&"
export * from "./draftactivitymanagetable.vue?vue&type=script&lang=js&"
import style0 from "./draftactivitymanagetable.vue?vue&type=style&index=0&id=0ce78ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce78ff5",
  null
  
)

export default component.exports